import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SpreadInterface } from '@campus/dal';

@Component({
  standalone: false,
  selector: 'campus-score-scatter-v2',
  templateUrl: './score-scatter-v2.component.html',
  styleUrls: ['./score-scatter-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreScatterV2Component implements OnChanges {
  @HostBinding('class.pages-results-v2-score-scatter') hasScoreScatterClass = true;

  @Input() spread: SpreadInterface;

  public spreadData = {
    low: 0,
    medium: 0,
    high: 0,
  };

  ngOnChanges(changes: SimpleChanges): void {
    this.spreadData = changes.spread.currentValue;
  }
}
